import {createSlice} from "@reduxjs/toolkit";

const initialVehiclesState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  vehicleForEdit: undefined,
  lastError: null,
  locations: null,
  locationsTotalCount: 0
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const vehiclesSlice = createSlice({
  name: "vehicles",
  initialState: initialVehiclesState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getVehicleById
    vehicleFetched: (state, action) => {
      state.actionsLoading = false;
      state.vehicleForEdit = action.payload.vehicleForEdit;
      state.error = null;
    },
    // findVehicles
    vehiclesFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    //findLocations
    locationsFetched: (state, action) => {
      const { locationsTotalCount, locations } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.locations = locations;
      state.locationsTotalCount = locationsTotalCount;
    },
    // createVehicle
    vehicleCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.vehicleForEdit = action.payload.vehicle;
      state.entities.push(action.payload.vehicle);
    },
    // updateVehicle
    vehicleUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.id === action.payload.vehicle.id) {
          return action.payload.vehicle;
        }
        return entity;
      });
    },
    // deleteVehicle
    vehicleDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.id !== action.payload.id);
    },
    // deleteVehicles
    vehiclesDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.id)
      );
    },
    // vehiclesUpdateState
    vehiclesStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map(entity => {
        if (ids.findIndex(id => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    }
  }
});
